import { normalizeImageProvider } from '../constants/globalAiProviders';
import { assertDatastartImageInputLimit, DATASTART_IMAGE_QUALITY_OPTIONS, isDatastartImageProvider } from '../constants/datastartImageModels';

export const WANX_IMAGE_MAX_INPUT_IMAGES = 3;
export const WANX_IMAGE_MAX_QUALITY_TIER = '2K';
export const IMAGE_PROVIDER_STORAGE_KEY = 'image_provider';
export const IMAGE_PROVIDER_CHANGE_EVENT = 'image-provider-change';

const normalizeProviderId = (provider) => String(provider || '').trim().toLowerCase();
const hasTwoKLimit = (provider) => ['wanx', 'astraflow_grok'].includes(normalizeProviderId(provider));

export const getCurrentImageProvider = () => {
  const storedProvider = typeof window !== 'undefined'
    ? (window.localStorage?.getItem(IMAGE_PROVIDER_STORAGE_KEY)
      || window.localStorage?.getItem('ai_provider'))
    : null;
  return normalizeImageProvider(normalizeProviderId(storedProvider));
};

export const setStoredImageProvider = (provider) => {
  const normalizedProvider = normalizeImageProvider(normalizeProviderId(provider));
  if (typeof window !== 'undefined') {
    window.localStorage?.setItem(IMAGE_PROVIDER_STORAGE_KEY, normalizedProvider);
    window.dispatchEvent(new CustomEvent(IMAGE_PROVIDER_CHANGE_EVENT, {
      detail: { provider: normalizedProvider },
    }));
  }
  return normalizedProvider;
};

export const isWanxImageProvider = (provider = getCurrentImageProvider()) => (
  normalizeProviderId(provider) === 'wanx'
);

export const normalizeWanxImageQualityTier = (
  qualityTier,
  provider = getCurrentImageProvider(),
) => (
  isDatastartImageProvider(provider) ? '1K'
    : hasTwoKLimit(provider) && String(qualityTier || '').trim().toUpperCase() === '4K'
    ? WANX_IMAGE_MAX_QUALITY_TIER
    : qualityTier
);

export const getWanxCompatibleQualityOptions = (
  options,
  provider = getCurrentImageProvider(),
) => (
  isDatastartImageProvider(provider) ? DATASTART_IMAGE_QUALITY_OPTIONS
    : hasTwoKLimit(provider)
    ? (options || []).filter((option) => String(option?.value || '').trim().toUpperCase() !== '4K')
    : (options || [])
);

const countImageInputs = (imagesOrCount) => {
  if (Array.isArray(imagesOrCount)) {
    return imagesOrCount.filter(Boolean).length;
  }
  const count = Number(imagesOrCount);
  return Number.isFinite(count) ? Math.max(0, count) : 0;
};

export const assertWanxImageInputLimit = (
  imagesOrCount,
  provider = getCurrentImageProvider(),
) => {
  const inputCount = countImageInputs(imagesOrCount);
  // 保留旧函数名供已有入口复用，同时集中执行新增纯图片线路的限制。
  assertDatastartImageInputLimit(inputCount, provider);
  if (isWanxImageProvider(provider) && inputCount > WANX_IMAGE_MAX_INPUT_IMAGES) {
    throw new Error(
      `千问图像3.0最多支持${WANX_IMAGE_MAX_INPUT_IMAGES}张输入图片，当前共${inputCount}张，请删除多余图片`,
    );
  }
  return inputCount;
};
